// components/PusherListener.tsx
import { useEffect } from 'react';
import Pusher from 'pusher-js';
import { toast } from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { ACTIONS, PUSHER_CRED } from '../_config';
import { PusherResponse } from '../_config/interfaces/interfaces';

const PusherListener = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!PUSHER_CRED.KEY || !PUSHER_CRED.CLUSTER) {
      toast.error("Pusher credentials are not correct");
      return;
    }

    const pusher = new Pusher(PUSHER_CRED.KEY, {
      cluster: PUSHER_CRED.CLUSTER,
    });

    const channel = pusher.subscribe("import-update");

    channel.bind("progress-update", (data: PusherResponse) => {
    //   console.log("Received Pusher Event:", data);
      dispatch({ type: ACTIONS.PUSHER.ADD_DATA, payload: data });
    });

    return () => {
      channel.unbind_all();
      channel.unsubscribe();
      pusher.disconnect();
    };
  }, []);

  return null;
};

export default PusherListener;
